import { render, staticRenderFns } from "./BulkPayment.vue?vue&type=template&id=5d43e58a&scoped=true"
import script from "./BulkPayment.vue?vue&type=script&lang=js"
export * from "./BulkPayment.vue?vue&type=script&lang=js"
import style0 from "./BulkPayment.vue?vue&type=style&index=0&id=5d43e58a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d43e58a",
  null
  
)

export default component.exports